
import { GlobalResponseObject, ErrorResponse } from "@schemax-whatsapp/shared-models";

export class ApplicationExceptionHandler {
    constructor() {
        // do nothing
    }

    returnException<T extends GlobalResponseObject>(classType: new (status: boolean, errorCode: number, internalMessage: string, data?: any) => T, errorObj: any): T {
        let errorCode: number = 0;
        let message: string = '';
        if (errorObj instanceof ErrorResponse) {
            errorCode = errorObj.errorCode;
            message = errorObj.message;
        } else if (errorObj instanceof Error) {
            errorCode = 0;
            message = errorObj.message;
        }
        const responseObj = new classType(false, errorCode, message);
        responseObj.status = false;
        responseObj.errorCode = errorCode;
        responseObj.internalMessage = message;
        return responseObj;
    }
}